export default __webpack_public_path__ + "static/media/fire-ray-3000.ffdd4ff4.jpg";